<script lang="ts">
  import { Col } from "sveltestrap";
  import Card from "../../Core/Card.svelte";
  import { SteplineChart } from "../../../utils/Constant/Constant";
  import { chart } from "svelte-apexcharts";
  import {SteplineChartData} from "../../../Data/Chart/Charts/ApexChart"

</script>
<Col sm="12" xl="6" class="box-col-6">
    <Card cardHeaderprops="pb-0" headerTitle={SteplineChart}>
      <div slot="contentbody">
        <div id="stepline">
          <div use:chart={SteplineChartData} />
        </div>
      </div>
    </Card>
</Col>